
<template>
  <div class="post-suc">
    <img src="../assets/images/images/suc1.png" class="img" alt>
    <div class="f17" style="font-weight:bold;margin-top:10px;text-align:center;color:#808080">提交成功</div>
    <div class="f17" style="color:grey;margin-top:45px;text-align:center;">系统审核需要时间，请勿重复提交！</div>
    <div class="middleInfo">
      <div :class="active1?'active':''" @touchend="gtouchend(1)" @touchstart="gtouchstart(1)" @click="goManger">管理信息</div>
      <div :class="active2?'active':''" @touchend="gtouchend(2)" @touchstart="gtouchstart(2)" @click="go(1)">回到首页</div>
      <div :class="active3?'active':''" @touchend="gtouchend(3)" @touchstart="gtouchstart(3)" @click="go(0)">再发一条</div>
    </div>
    <!--tips-->
    <div class="tips">
      <div class="tipsTop">
        <div>
          <img src="../assets/images/images/successInfo.png" alt="">
        </div>
        <div><div>开通VIP刷新靠前显示服务</div><div style="text-align:left;">增加曝光，加速成交!<span style="font-size:13px;font-weight:bold;">(包周)</span></div></div>
      </div>
      <div class="tipsMiddle">
        此服务共含{{mounthNum}}次VIP刷新权限，信息刷新后能再次靠前显示，可在“我的发布”里操作！
      </div>
      <div class="tipsBottom">
        （注：每天最多刷新{{dataNum}}次，7天内使用完）
      </div>
      <div class="prePay">
        <div v-if="hasSelect" class="submitPay" @click="prePayMoney">
          开通，支付¥{{(moneyInfo.fee && moneyInfo.fee/100) || 0}}
        </div>
        <div v-else class="submitPay noSelect" >
          开通，支付¥{{(moneyInfo.fee && moneyInfo.fee/100) || 0}}
        </div>
      </div>
    </div>
    <div style="display:flex;justify-content:center;margin-top:18px;">
      <div>
        <img style="width:20px;height:auto;margin:0;" src="../assets/images/images/huojian.png" class="img" alt>
      </div>
    </div>
    <div class="bottom-info" @click="jumpSuperVip">
      升为超级会员，享多重特权 开通 >
    </div>
    <!-- <div class="selectPrice">
      <div>
        <img v-if="hasSelect" src="../assets/images/images/select.png" alt="" @click="changeSelectStatus">
        <img v-else src="../assets/images/images/closeSelect.png" alt="" @click="changeSelectStatus">
      </div>
      <div class="priceSec">
        <span>VIP刷新价</span><span>{{moneyInfo.fee/100}}元/周</span>
      </div>
    </div> -->
    <!--确认支付-->
    
  </div>
</template>

<script>
let me;
import { getData, postData } from "../Interface/http.js";
import { Dialog } from "vant";
export default {
  name: "PostSuc",
  data() {
    return {
      hasSelect:true,
      dataNum:5,//每天刷新的次数
      mounthNum:30,//每月刷新的次数
      moneyInfo:{},//付款信息
      vipStatus:{},//当前用户是否已开通vip，0：未开通，1：已开通
      loginStatus: false, //是否已经登录
      active1: false, //按钮一激活
      active2: false, //按钮二激活
      active3: false //按钮三激活
    };
  },
  methods: {
    jumpSuperVip() {
      this.$router.push({
        name: 'superVip'
      })
    },
    //按下
    gtouchstart(index) {
      this['active'+index] = true;
    },
    //抬起
    gtouchend(index) {
      this['active'+index] = false;
    },
    //跳转到我的管理页面
    goManger(){
      if (!me.loginStatus) {
        //如果未登录
        me.login();
        return;
      }
      this.$router.replace({
          name: "myPushMsg"
        });
    },
    //跳转页面
    go(index) {
      if (index == 0) {
        this.$router.replace({
          name: "post",
          params: { mes: { id: 1, title: "信息汇总" } }
        });
      } else {
        this.$store.commit("UPDATEATBINDEX", { tag: 0 });
        this.$router.replace({ name: "home" });
      }
    },
    //获取每日和每月刷新数
    getDayAndMounthCount() {
      getData("/vip/refresh-num").then(res=>{
        me.dataNum = res.data.day_refresh_num;//每日数量
        me.mounthNum = res.data.month_refresh_num;//每月数量
      }).catch(err=>{
        console.log(err);
      })
    },
    //获取VIP刷新体验价格
    getVipPrice() {
      getData("/vip/user-ob").then(res=>{
        me.moneyInfo = res.data[0];
      }).catch(err=>{
        console.log(err);
      })
    },
    //确认支付
    prePayMoney() {
      if (!me.loginStatus) {
        //如果未登录
        me.login();
        return;
      }
      if(me.vipStatus.type=="on"){
        this.$toast(me.vipStatus.msg)
        return;
      }
      postData("/payment/order/create", {
        trade_type: "mp",
        plan_id: me.moneyInfo.id,
      })
        .then((res) => {
          me.onBridgeReady(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //调起微信支付
    onBridgeReady(msg) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        msg,
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            Dialog.setDefaultOptions({
              confirmButtonText:"回首页",
              cancelButtonText:"去刷新"
            })
            Dialog.confirm({
              title: "支付成功",
              message: "恭喜你支付成功",
            }).then(()=>{
              me.$router.push({
                name:"home"
              })
            }).catch(()=>{
              me.$router.push({
                name:"myPushMsg"
              })
            })
            Dialog.resetDefaultOptions();
          }
        }
      );
    },
    //获取用户当前的开通状态
    getUserStatus(){
      postData("/vip/is-pay",{
        type:"user"
      }).then(res=>{
        me.vipStatus = res.data;
      }).catch(err=>{
        console.log(err);
      })
    },
    //改变勾选状态
    changeSelectStatus() {
      me.hasSelect = !me.hasSelect;
    },
    //为授权登录，登录页面
    login() {
      getData("/oauth/redirect/wechat").then(res => {
        localStorage.setItem("startPage", "postSuc");
        window.location.href = res.data.redirect_url;
      });
    },
  },
  mounted(){
    me=this;
    me.getDayAndMounthCount();
    me.getVipPrice();
    me.getUserStatus();
    if (
      localStorage.getItem("token") == null ||
      localStorage.getItem("token") == "123456"
    ) {
      this.loginStatus = false;
    } else {
      this.loginStatus = true;
    }
  }
};
</script>

<style scoped>
.img {
  width: 40px;
  height: 40px;
  margin-top: 40px;
}
.bottom-info {
  margin: 0 38px;
  padding: 10px 0;
  background: #E7D4E6;
  border-radius: 5px;
  color: #882784;
  font-weight: bold;
  font-size: 18px;
}
.middleInfo {
  display: flex;
  justify-content:space-between;
  margin: 20px 38px;
}
.middleInfo>div{
  width: 70px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #882784;
  padding: 0px 6px;
  border-radius: 5px;
}
.tips{
  background-color: #E7D4E6;
  margin: 20px 38px 0 38px;
  border-radius: 5px;
  padding:10px 5px;
}
.tipsTop{
  font-size:18.5px;
  display: flex;
  align-items: center;
  font-weight:bold;
  color:#882784;
}
.tipsTop>div:nth-child(1){
  width:38px;
  height:38px;
  margin: 0 12px;
  flex-shrink: 0;
}
.tipsTop img{
  width:38px;
  height: 38px;
  flex-shrink: 0;
}
.tipsMiddle{
  font-size: 14px;
  margin-top: 5px;
  text-align: center;
  color:#000000;
}
.tipsBottom {
  font-size: 14px;
  color:#000000;
  text-align: center;
}
.selectPrice {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
}
.selectPrice>div:nth-child(1) {
  margin-right: 10px;
  display: flex;
  align-items: center;
}
.selectPrice img {
  width: 20px;
  height: 20px;
}
.priceSec {
  font-weight: bold;
  color: #882784;
  font-size: 20px;
}
.priceSec>span:nth-child(2) {
  font-weight: bolder;
  font-size: 23px;
}
.submitPay {
  display: flex;
  justify-content: center;
  align-items: center;
  width:fit-content;
  border-radius:5px;
  padding: 5px 70px;
  font-weight: bold;
  background-color:#882784;
  height:30px;
  color:#fff;
}
.noSelect {
   background-color:#CBCBCB;
}
.prePay {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 20px;
}
.active {
  background-color: #882784;
  color: #fff;
}
</style>
